import { useMeta } from '@/hooks/useMeta';

export default function PrivacyPolicy() {
  useMeta({
    title: 'Privacy Policy | AmericanTrademark Firm',
    description: 'Read AmericanTrademark Firm\'s Privacy Policy. Learn how we collect, use, and protect your personal information when you use our trademark and IP services.',
    keywords: 'privacy policy, data protection, personal information, AmericanTrademark Firm privacy',
  });

  return (
    <div data-testid="privacy-page">
      <section className="relative py-24 md:py-36 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1521791055366-0d553872125f?w=1920&q=80)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#09090B]/80 via-[#09090B]/65 to-[#09090B]/40" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#6B9FFF] mb-4">Legal</p>
          <h1 className="font-heading font-black text-5xl md:text-6xl tracking-tighter leading-none text-white">
            Privacy Policy
          </h1>
        </div>
      </section>
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-12 font-body text-zinc-600 leading-relaxed space-y-8">
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Introduction</h2>
            <p>AmericanTrademark Firm ("we," "us," or "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.</p>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Information We Collect</h2>
            <p className="mb-3">We may collect information about you in a variety of ways. The information we may collect includes:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Personal Data:</strong> Name, email address, phone number, and other contact information you voluntarily provide when filling out forms on our website.</li>
              <li><strong>Usage Data:</strong> Information about how you access and use our website, including your IP address, browser type, operating system, pages viewed, and the dates and times of your visits.</li>
              <li><strong>Location Data:</strong> We may collect your approximate location based on your IP address to provide better service and pre-populate form fields.</li>
            </ul>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">How We Use Your Information</h2>
            <p className="mb-3">We use the information we collect for various purposes, including:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>To provide, operate, and maintain our services</li>
              <li>To communicate with you about your inquiries and service requests</li>
              <li>To improve our website and user experience</li>
              <li>To send you relevant service updates and marketing communications</li>
              <li>To comply with legal obligations</li>
            </ul>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Data Security</h2>
            <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure.</p>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Third-Party Services</h2>
            <p>We may share your information with trusted third-party service providers who assist us in operating our website and delivering our services. These parties are obligated to maintain the confidentiality of your information and are prohibited from using it for any other purpose.</p>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Your Rights</h2>
            <p>You have the right to access, correct, or delete your personal information. You may also opt out of receiving marketing communications at any time. To exercise these rights, please contact us using the information provided on our Contact Us page.</p>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page. Your continued use of our website after any changes constitutes your acceptance of the updated policy.</p>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us through our Contact Us page or email us at info@americantrademarkfirm.com.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
